import { css } from 'lit';
export const styles = css `
:host(:focus){outline:0}.-hds-breadcrumb-wrapper .breadcrumb{background-color:initial;display:flex;flex-wrap:wrap;list-style:none;margin:var(--hds-spacing-0);padding-left:0;transition:all .15s ease-in-out}
`;
//# sourceMappingURL=hds-breadcrumb.css.js.map